// extracted by mini-css-extract-plugin
export default {"background":"paymentpage_background__Lb3zB","cart":"paymentpage_cart__z4Lq3","shippingText":"paymentpage_shippingText__K+hFS"};